import { AccessTime } from '@mui/icons-material';
import React from 'react';

import { OverdueAndDueDatesResponse } from '../../../../../../../lib/api/fundsDashboard/fundsDashboard';
import PieChart from '../../../../../../../lib/designSystem/Charts/PieChart';

interface OverdueByDaysChartProps {
  data: OverdueAndDueDatesResponse;
}

const OverdueByDaysChart: React.FC<OverdueByDaysChartProps> = ({ data }) => {
  const chartData = React.useMemo(() => {
    if (!data?.overdueByDays) return [];

    return data.overdueByDays.map((item) => ({
      id: item.range,
      label: item.range,
      value: item.count,
    }));
  }, [data?.overdueByDays]);

  return (
    <PieChart
      data={chartData}
      title="Distribución de Mora por Días"
      icon={<AccessTime sx={{ fontSize: 18, color: '#9c27b0' }} />}
      color="#9c27b0"
    />
  );
};

export default OverdueByDaysChart;
